import Phaser from "phaser";
import GameObject from "./GameObject";
import Empty from "./Empty";
import { CLASS_NAMES, PIXEL_NAME } from "../../utils/constants";

export default class Explosion extends GameObject {
  constructor(id, level) {
    super({
      id,
      isRigid: false,
      isBreakable: false,
      isFlat: true,
      isPickable: false,
      isCrushable: false,
      level,
    });
    this.power = 10;
    this.strength = 10;
    this.extinguished = false;
  }
  setPosition(coords) {
    super.setPosition(coords);
    const { x, y } = coords;

    const layer = this.level.scene.children.getByName("layer_1");
    // when player dies and level is restarting but explosions still occuring, layer is null
    if (!layer) return false;

    const { tilemap: map } = layer;

    const explosion = this.level.scene.add
      .sprite(48, 16)
      .setOrigin(0.125, 0.125)
      .play("explosion_explode");
    explosion.setScale(layer.scaleX);
    explosion.x = map.tileToWorldX(x);
    explosion.y = map.tileToWorldY(y);

    // this.level.pause()
    explosion.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
      explosion.destroy();
      this.extinguished = true;
      // avoid to wipe out a non explosion object what provokes a ghost element
      if(this.level.objects[y][x].isClass(CLASS_NAMES.EMPTY) || this.level.objects[y][x].isClass(CLASS_NAMES.EXPLOSION)) {
        this.level.objects[y][x] = new Empty(PIXEL_NAME.EMPTY, this.level);
      }
    });

    this.alien = explosion;

    this.level.replaceByEmpty(this);
    this.level.onNextTick((lvl) => {
      // destroy explosion in the next tick or it will prevent the objects above it to wait for a 2nd tick to start falling
      // this is bcs barrels explode with an offset of tick/2 but explosion places are reserved when barrel cruashes
      // therefore the explosions takes 1 tick from half to half causing the object above to wait an extra tick
      // lvl.objects[y][x] = new Empty(PIXEL_NAME.EMPTY, this.level)
      // lvl.replaceByEmpty(this)
    });
  }
}

Explosion.className = CLASS_NAMES.EXPLOSION;
